const translations = {
  "en": {
    "KRW": "KRW"
  },
  "zh-tw": {
    "KRW": "韓元"
  }
};

export default translations;
